module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"text":"How to&nbsp;launch a&nbsp;corporate gateway visited by&nbsp;over 500 employees every day?","button":"Read the full story"},"ru":{"text":"Как запустить корпоративный портал, который ежедневно будут посещать больше 500&nbsp;сотрудников.","button":"Читать историю"}}')
  delete Component.options._Ctor
}
